import { Portlet, PortletBody } from "../../../../../partials/content/Portlet";
import PortletSpinner from "../../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import * as internalEstimateCrud from '../../../../../crud/internalEstimate.crud';
import { withListPageProps } from '../../../../../shared/hoc/withListPageProps';
import BaseListPage from '../../../_CustomComponents/BaseListPage';
import { internalEstimateStatuses, lifeCycleStages } from '../../../../../shared/lookup';
import Common from '../../../../../shared/common';

export const getEstimateBadgeVariantByStatus = (status) => {
    //0: SUPERSSEDED, 1: ACTIVE, 2: MANUALLYSUPERSEDED
    //danger - red, warning - yellow, secondary - grey, success - green, primary - blue
    switch (status) {
        case 0:
            return 'warning';
        case 1:
            return 'success';
        case 2:
            return 'danger';
        default:
            return 'secondary';
    }
};

/**
 * Generic Internal Estimates List Component
 * Works with any parent workflow (CE, EW, Instruction)
 */
class InternalEstimateListPage extends BaseListPage {
    constructor(props) {
        super(props);
        
        this.estimateStatuses = internalEstimateStatuses;

        this.lifecycleStages = [
            { value: 'EW', display: 'Early Warning' },
            { value: 'INSTRUCTION', display: 'Instruction' },
            { value: 'CE', display: 'Compensation Event' }
        ];

        this.state = {
            ...this.state,
            estimates: []
        };
    }

    componentDidMount() {
        this.fetchEstimates();
    }

    fetchEstimates = () => {
        internalEstimateCrud.getInternalEstimateHistory(this.props.parentNotification.lineageid)
            .then(response => {
                this.setState({
                    estimates: response.data || []
                });
            })
            .catch(error => {
                console.error('Error fetching estimates:', error);
            });
    };

    renderStatusColumn = (data) => {
        let badgeVariant = getEstimateBadgeVariantByStatus(data.value);
        const status = this.estimateStatuses.find(s => s.value === data.value)?.display || data.value;
        return (<Badge variant={badgeVariant}>{status}</Badge>);
    }

    renderStageColumn = (data) => {
        const stage = lifeCycleStages.find(s => s.value === data.value)?.display || data.value;
        return stage;
    }

    calculateTimeImpactValue = (data) => {
        return data.value + ' ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' });
    }

    getFormFields = () => {
        const { fields } = this.props.workflowItem;
        const formFields = [];

        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.ID' }),
            dataField: 'referenceid',
            dataType: 'string',
            //width: 150
        });

        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.STAGE' }),
            dataField: 'workflowid',
            dataType: 'string',
            //width: 130,
            // cellRender: (data) => {
            //     const statusDisplay = this.estimateStatuses.find(s => s.value === data.value)?.display || data.value;
            //     return (
            //         <Badge bg={getEstimateBadgeVariantByStatus(data.value)}>
            //             {statusDisplay}
            //         </Badge>
            //     );
            // }
            cellRender: this.renderStageColumn
        });

        if (fields.PriceImpact?.visible) {
            formFields.push({
                caption: fields.PriceImpact.label || 'Price Impact',
                dataField: 'priceimpact',
                dataType: 'money',
                //width: 120
                cellRender: (data) => {
                    return (
                        Common.FormatCurrencyNum(data.value, data.data.currency)
                    )
                }
            });
        }

        if (fields.TimeImpact?.visible) {
            formFields.push({
                caption: fields.TimeImpact.label || 'Time Impact',
                dataField: 'timeimpact',
                dataType: 'integer',
                cellRender: this.calculateTimeImpactValue
                //width: 100
            });
        }

        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.STATUS' }),
            dataField: 'status',
            dataType: 'string',
            //width: 130,
            // cellRender: (data) => {
            //     const statusDisplay = this.estimateStatuses.find(s => s.value === data.value)?.display || data.value;
            //     return (
            //         <Badge bg={getEstimateBadgeVariantByStatus(data.value)}>
            //             {statusDisplay}
            //         </Badge>
            //     );
            // }
            cellRender: this.renderStatusColumn
        });

        return formFields;
    };

    onSelectionChanged = ({ selectedRowsData }) => {
        const { workflowItem } = this.props;

        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            this.props.navigate(`${workflowItem.paths.basePath}${data.internalestimateid}`);
        }
    }

    render() {
        const { estimates } = this.state;
        const { workflowItem } = this.props;

        if (!estimates) {
            return (<PortletSpinner />);
        }

        return (
            <Portlet>
                <PortletBody>
                    {/* {activeEstimate && (
                        <Alert variant="info" className="mb-3">
                            <strong>Current Active Estimate:</strong> {activeEstimate.estimatereference} 
                            ({this.lifecycleStages.find(s => s.value === activeEstimate.lifecyclestage)?.display || activeEstimate.lifecyclestage})
                            - Price: £{activeEstimate.priceimpact?.toLocaleString()}, 
                            Time: {activeEstimate.timeimpact} days
                        </Alert>
                    )} */}

                    <DataGridBase
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        createPath={Common.createAllowedInternalEstimate(workflowItem) ? this.props.workflowItem.paths.createPath : null}
                        name={this.props.workflowItem.pageTitle}
                        keyExpr="internalestimateid"
                        dataSource={estimates}
                        columns={this.getFormFields()}
                        showRowNumbers={true}
                        selectedRowKeys={[]}
                        onSelectionChanged={this.onSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}

export default withListPageProps(InternalEstimateListPage);
